import { motion, useMotionValue, useScroll, useSpring, useTransform } from "framer-motion";
import { EASE } from "@/lib/site";

const RotatingBadge = () => (
  <div className="absolute -left-6 bottom-16 sm:-left-10 h-24 w-24 sm:h-28 sm:w-28 rounded-full bg-[#070A12] border border-amber-200/20 grid place-items-center z-20" style={{ transform: "translateZ(60px)" }}>
    <svg viewBox="0 0 100 100" className="absolute inset-0 animate-spin-slow">
      <defs><path id="circ" d="M50,50 m-38,0 a38,38 0 1,1 76,0 a38,38 0 1,1 -76,0" /></defs>
      <text className="font-mono" fontSize="8.4" letterSpacing="3" fill="#F3E5AB">
        <textPath href="#circ">SALES · MARKETING · LEGACY · </textPath>
      </text>
    </svg>
    <span className="font-display italic text-2xl text-amber-300">RM</span>
  </div>
);

export const Portrait = ({ badge, badgeSub }) => {
  const { scrollY } = useScroll();
  const parallax = useTransform(scrollY, [0, 800], [0, 90]);
  const imgScale = useTransform(scrollY, [0, 800], [1.06, 1.18]);
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const rx = useSpring(useTransform(my, [-0.5, 0.5], [8, -8]), { stiffness: 120, damping: 18 });
  const ry = useSpring(useTransform(mx, [-0.5, 0.5], [-10, 10]), { stiffness: 120, damping: 18 });

  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    mx.set((e.clientX - r.left) / r.width - 0.5);
    my.set((e.clientY - r.top) / r.height - 0.5);
  };
  const onLeave = () => { mx.set(0); my.set(0); };

  return (
    <motion.div style={{ y: parallax }} className="relative mx-auto w-full max-w-[340px] sm:max-w-[400px] lg:max-w-none [perspective:1200px]"
      initial={{ opacity: 0, scale: 0.94 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 1.4, delay: 0.3, ease: EASE }}>
      <motion.div data-testid="hero-portrait" onMouseMove={onMove} onMouseLeave={onLeave} style={{ rotateX: rx, rotateY: ry, transformStyle: "preserve-3d" }} className="relative">
        <div className="absolute -inset-4 rounded-t-[999px] rounded-b-[28px] border border-amber-200/25" style={{ transform: "translateZ(-40px)" }} />
        <div className="portrait-glow absolute -inset-10 -z-10 rounded-full" />
        <div className="relative aspect-[4/5] overflow-hidden rounded-t-[999px] rounded-b-[28px] bg-[#1a1f2b] shadow-[0_40px_120px_-30px_rgba(229,193,88,0.35)]">
          <motion.img src="/assets/rinda.jpg" alt="Rinda Marbun" style={{ scale: imgScale }} className="h-full w-full object-cover object-[50%_20%]" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#070A12]/70 via-transparent to-transparent" />
        </div>
        <RotatingBadge />
        <div data-testid="hero-badge" className="absolute -right-3 sm:-right-8 top-[18%] rounded-2xl border border-amber-200/20 bg-[#0B1020]/80 backdrop-blur-xl px-4 py-3 shadow-2xl" style={{ transform: "translateZ(80px)" }}>
          <p className="font-display text-lg text-slate-50 leading-tight">{badge}</p>
          <p className="font-mono text-[11px] uppercase tracking-widest text-amber-200/80 mt-1">{badgeSub}</p>
        </div>
      </motion.div>
    </motion.div>
  );
};
